import React from 'react'
import styled from 'styled-components'
import {BsArrowRight} from 'react-icons/bs'
import Tangerine from "../assets/Tangerine.png"

const Projects = ({projectDescription, project, projectUrl, imgSrc}) => {
  return (
        <ProjectStyled>
              <div className="project-container">
                <div className="text-area">
                    <h1>
                      {project}
                    </h1>
                    <p>
                       {projectDescription}
                    </p>
                    <a href={projectUrl} >View Project  <BsArrowRight/></a>
                </div>
                <div className="image-container">
                    <img src={imgSrc} alt="Tangerine"/>
                </div>

                <a className='mobileLink' href={projectUrl} >View Project  <BsArrowRight/></a>
              </div>
        </ProjectStyled>
  )
}

export default Projects

const ProjectStyled = styled.div`
  background-color: #FFE1F0;
  margin-top: 0rem;
  .project-container{
    display: flex;
    padding: 3.5625rem 10% 5.5rem 10%;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
    }
    .text-area{
      h1{
        font-size: 5.5rem;
        font-weight: 500;
        font-family: 'Space Grotesk', sans-serif;
        color: #000000;
        margin-bottom: 1.875rem;

        @media (max-width: 768px) {
          font-size: 2.5rem;
        }
      }
      p{
        font-size: 1.875rem;
        font-family: 'Nunito', sans-serif;
        color: #4F4F4F;
        max-width: 36.125rem;
        margin-bottom: 2.5rem;

        @media (max-width: 768px) {
          font-size: 1.125rem;
          line-height: 1.5rem; 
        }
      }

      a{
        font-family: 'Space Grotesk', sans-serif;
        color: #000000;
        font-size: 2.1875rem;
        font-weight: 500;
        text-decoration: none;
        display: flex;
        align-items: center;
        column-gap: 1.738125rem;

        @media( max-width: 768px){
            display: none;
        }
      }
    }

    .mobileLink{
        font-family: 'Space Grotesk', sans-serif;
        color: #000000;
        font-size: 1.375rem;
        font-weight: 500;
        text-decoration: none;
        display: none;
        align-items: center;
        column-gap: 0.7375rem;
        @media( max-width: 768px){
            display: flex;
        }
    }

    .image-container{
      max-width: 28.75rem;
      height: 100%;
      img{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }   
`